import { useCookieState } from '@dustin-web/microsite-components/src/hooks/use-cookie-state'
import { useQueryState } from '@dustin-web/microsite-components/src/hooks'

// TODO @John Turesson
export type ProductCardType = 'gallery' | 'extended' | 'compact' | 'stripped' | string | null

type ProductListSettingsType = {
  pageSize: number
  sortBy: string
  viewType: ProductCardType
}

export const useProductListSettings = () => {
  const {
    cookies: {
      userSettings: { pageSize, sortBy, viewType },
    },
  } = useCookieState()
  const { queryState } = useQueryState()

  return {
    pageSize: parseInt(pageSize ?? '20'),
    sortBy: queryState.sortby || sortBy || 'sales',
    viewType: viewType ?? 'extended',
  } as ProductListSettingsType
}
